/**
 * Smooth-scrolls to the element a wrapped in-page link points at (href="#id").
 * The plain link still works without JS; this makes the jump reliable in previews and on phones,
 * and moves focus to the target for keyboard and screen-reader users.
 */
class SScrollLink extends HTMLElement {
  connectedCallback() {
    this.link = this.querySelector('a[href^="#"]');
    if (!this.link) return;
    this.onClick = (event) => {
      const target = document.getElementById(this.link.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    };
    this.link.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.link?.removeEventListener('click', this.onClick);
  }
}

if (!customElements.get('s-scroll-link')) customElements.define('s-scroll-link', SScrollLink);
